<template>
  <span>
    <button
      type="button"
      class="btn btn-sm btn-link p-0 sv__botao"
      :title="titulo"
      @click="abrir"
    >
      <feather-icon
        icon="EditIcon"
        size="14"
        class="mr-25"
      />
      {{ rotulo }}
    </button>

    <b-modal
      v-model="aberto"
      :title="titulo"
      size="md"
      centered
      lazy
      hide-footer
    >
      <div class="sv__corpo">
        <div
          v-if="carregando"
          class="text-center py-4"
        >
          <b-spinner small />
        </div>
        <img
          v-else-if="imagem"
          :src="imagem"
          class="sv__imagem"
          alt="Assinatura"
        >
        <p
          v-else
          class="text-muted text-center mb-0 py-4"
        >
          Assinatura n&atilde;o dispon&iacute;vel.
        </p>
      </div>
    </b-modal>
  </span>
</template>

<script>
import ApiErrorMixin from '@/mixins/ApiErrorMixin'

export default {
  name: 'SignatureViewer',
  mixins: [ApiErrorMixin],

  props: {
    url: { type: String, required: true },
    rotulo: { type: String, default: 'Assinatura' },
    titulo: { type: String, default: 'Assinatura' },
  },

  data() {
    return {
      aberto: false,
      carregando: false,
      imagem: null,
    }
  },

  beforeDestroy() {
    this.descartar()
  },

  methods: {
    async abrir() {
      this.aberto = true

      if (this.imagem) return

      this.carregando = true
      try {
        const res = await this.$http.get(this.url, { responseType: 'blob' })
        this.descartar()
        this.imagem = URL.createObjectURL(res.data)
      } catch (e) {
        this.imagem = null
        this.$message('Erro', this.apiErrorText(e, 'Não foi possível carregar a assinatura.'), 'error')
      } finally {
        this.carregando = false
      }
    },

    descartar() {
      if (this.imagem) {
        URL.revokeObjectURL(this.imagem)
        this.imagem = null
      }
    },
  },
}
</script>

<style scoped>
.sv__botao {
  font-size: 12px;
}

.sv__corpo {
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sv__imagem {
  max-width: 100%;
  max-height: 320px;
  background: #fff;
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  padding: 6px;
}

.dark-layout .sv__imagem {
  border-color: #3b4253;
}
</style>
